export default {
      id: "circle-arrow-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-arrow-usage",
      toString: function () {
        return this.url;
      }
    }